import AgentPushMessage from './AgentPushMessage.component'

export default AgentPushMessage
